var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "calendark3d5ki91na",
    d: "M0 18L18 18 18 0 0 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-392 -413) translate(342 188) translate(40 100) translate(0 92) translate(10 33)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.174 2.348c-.215 0-.391.175-.391.391v14.087c0 .216.176.391.39.391h15.653c.215 0 .391-.175.391-.39V2.738c0-.216-.176-.391-.39-.391H1.173zM16.826 18H1.174C.527 18 0 17.473 0 16.826V2.74c0-.647.527-1.174 1.174-1.174h15.652c.647 0 1.174.527 1.174 1.174v14.087c0 .647-.527 1.174-1.174 1.174z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.74 3.13c-.217 0-.392-.175-.392-.39V.39c0-.216.175-.391.391-.391.216 0 .391.175.391.391V2.74c0 .216-.175.391-.39.391M5.87 3.13c-.216 0-.392-.175-.392-.39V.39c0-.216.176-.391.392-.391.216 0 .39.175.39.391V2.74c0 .216-.174.391-.39.391M9 3.13c-.216 0-.391-.175-.391-.39V.39C8.609.175 8.784 0 9 0c.216 0 .391.175.391.391V2.74c0 .216-.175.391-.391.391M12.13 3.13c-.216 0-.39-.175-.39-.39V.39c0-.216.174-.391.39-.391.216 0 .392.175.392.391V2.74c0 .216-.176.391-.392.391M15.26 3.13c-.215 0-.39-.175-.39-.39V.39c0-.216.175-.391.39-.391.217 0 .392.175.392.391V2.74c0 .216-.175.391-.391.391M9.391 8.608h2.348V6.26H9.783c-.216 0-.392.175-.392.391v1.957zm2.74.783H9c-.216 0-.391-.176-.391-.392V6.651c0-.647.526-1.174 1.174-1.174h2.347c.216 0 .392.176.392.392v3.13c0 .216-.176.392-.392.392z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.522 8.608h2.348V6.65c0-.216-.177-.39-.392-.39h-1.956v2.347zm2.739.783h-3.13c-.217 0-.392-.176-.392-.392V5.87c0-.216.175-.392.391-.392h2.348c.647 0 1.174.527 1.174 1.174V9c0 .216-.175.392-.391.392z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "calendarcalendarqenyslqeeb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#calendark3d5ki91na"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.391 11.74h2.348V9.39H9.391v2.348zm2.74.782H9c-.216 0-.391-.176-.391-.392V9c0-.216.175-.391.391-.391h3.13c.216 0 .392.175.392.391v3.13c0 .216-.176.392-.392.392z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.522 11.74h2.348V9.39h-2.348v2.348zm2.739.782h-3.13c-.217 0-.392-.176-.392-.392V9c0-.216.175-.391.391-.391h3.13c.217 0 .392.175.392.391v3.13c0 .216-.175.392-.391.392z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.391 14.87h2.348v-2.348H9.391v2.348zm2.74.782H9c-.216 0-.391-.175-.391-.391v-3.13c0-.217.175-.392.391-.392h3.13c.216 0 .392.175.392.391v3.13c0 .217-.176.392-.392.392z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.522 14.869h1.956c.215 0 .392-.176.392-.392v-1.956h-2.348v2.348zm1.956.782H12.13c-.216 0-.39-.175-.39-.39V12.13c0-.216.174-.392.39-.392h3.13c.217 0 .392.176.392.392v2.347c0 .648-.527 1.174-1.174 1.174zM3.13 11.738h2.348V9.391H3.522c-.215 0-.392.175-.392.39v1.957zm2.74.783H2.74c-.217 0-.392-.175-.392-.391V9.782c0-.647.527-1.174 1.174-1.174H5.87c.216 0 .39.175.39.391v3.13c0 .217-.174.392-.39.392z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.26 11.74H8.61V9.39H6.26v2.348zm2.74.782H5.87c-.216 0-.392-.176-.392-.392V9c0-.216.176-.391.392-.391H9c.216 0 .391.175.391.391v3.13c0 .216-.175.392-.391.392z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.13 12.521v1.956c0 .216.177.392.392.392h1.956V12.52H3.13zm2.74 3.13H3.522c-.647 0-1.174-.526-1.174-1.174V12.13c0-.216.175-.392.391-.392h3.13c.217 0 .392.176.392.392v3.13c0 .216-.175.391-.391.391z",
    mask: "url(#calendarqenyslqeeb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.26 14.87H8.61v-2.348H6.26v2.348zm2.74.782H5.87c-.216 0-.392-.175-.392-.391v-3.13c0-.217.176-.392.392-.392H9c.216 0 .391.175.391.391v3.13c0 .217-.175.392-.391.392z",
    mask: "url(#calendarqenyslqeeb)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.bcb79f050ba5f289248c3ab6bab079a6.svg";
export { ForwardRef as ReactComponent };